/**
 * Хелперы прав доступа для действий с вакансией
 */

/**
 * Проверяет, может ли пользователь создавать вакансию на основе заявки  
 * @param {string} userRole - Роль текущего пользователя
 * @returns {boolean}
 */
export const canCreateVacancyFromRequest = (userRole) => {
    const role = String(userRole || '');
    return role === 'superadmin' || role === 'admin' || role === 'hr';
};

/**
 * Проверяет, может ли пользователь создавать вакансию без заявки  
 * @param {string} userRole - Роль текущего пользователя
 * @returns {boolean}
 */
export const canCreateVacancyWithoutRequest = (userRole) => {
    const role = String(userRole || '');
    return role === 'superadmin';
};

/**
 * Проверяет, может ли пользователь редактировать карточку вакансию
 * @param {string} userRole - Роль текущего пользователя
 * @returns {{canEdit: boolean, reason: string}}
 */
export const canEditVacancy = (userRole) => {
    const role = String(userRole || '');
    if (role === 'superadmin' || role === 'admin' || role === 'hr') {
        return { canEdit: true, reason: '' };
    }
    return { canEdit: false, reason: 'У вас нет прав для редактирования вакансии' };
};

/**
 * Проверяет, может ли пользователь менять статус вакансии
 * @param {string} userRole - Роль текущего пользователя
 * @returns {boolean}
 */
export const canChangeVacancyStatus = (userRole) => {
    const role = String(userRole || '');
    return role === 'superadmin' || role === 'admin' || role === 'hr';
};

/**
 * Проверяет, может ли пользователь оставлять комментарии к вакансии
 * @param {string} userRole - Роль текущего пользователя
 * @returns {boolean}
 */
export const canCommentOnVacancy = (userRole) => {
    const role = String(userRole || '');
    return role === 'superadmin' || role === 'admin' || role === 'hr';
};

/**
 * Проверяет, является ли пользователь лидером
 * @param {string} userRole - Роль текущего пользователя
 * @returns {boolean}
 */
export const isLeaderRole = (userRole) => String(userRole || '') === 'leader';


